import { IconButton } from '@/components/ui/icon-button'
import { AppTooltip } from '@components'
import { Search } from 'lucide-solid'
import { useService } from 'solid-services'
import GlobalSearch, { shortcutLabel } from './GlobalSearch'
import { useGlobalSearch } from './state'

export { GlobalSearch, useGlobalSearch }
export { Highlight } from './Highlight'

/** Icon button that opens the global search; used in the desktop rail and the mobile top bar */
export function SearchTrigger(props: { tooltipPlacement?: 'right' | 'bottom' }) {
  const { open } = useService(useGlobalSearch)()

  return (
    <AppTooltip
      content={`Search (${shortcutLabel})`}
      delay={600}
      positioning={{ placement: props.tooltipPlacement ?? 'right' }}
    >
      <IconButton aria-label='Search' color='fg.subtle' width='100%' size='sm' variant='plain' onClick={() => open()}>
        <Search />
      </IconButton>
    </AppTooltip>
  )
}
